export default "__VITE_ASSET__I89MtOZI__"